import { Navbar, Nav } from 'react-bootstrap';
import { NavLink } from "react-router-dom";
import React from 'react';

const MainNavBar = () => {

    return (
        <Navbar bg="dark" variant="dark" fixed="top" expand="md">
            <Navbar.Brand href="/">
            <img
                src={require('../../assets/imgs/carlisle-homes.png')}
                width="40"
                className="d-inline-block align-center"
                alt="BetterBuild Console"
            />
            {' BetterBuild Console'}
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse>
                <Nav className="ml-auto">
                        { loadTopNavLinks(navLinks) }
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    )

}


export default MainNavBar;


const navLinks = [
    { to:"/search", activeClassName:"active", exact:false, pathname:'Replay'},
    { to:"/cache", activeClassName:"active", exact:false, pathname:'Cache'},
    { to:"/status", activeClassName:"active", exact:true, pathname:'Status'},
    { to:"/api", activeClassName:"active", exact:true, pathname:'API'},
];

const loadTopNavLinks = (navLinks) => {
    return navLinks.map( (navLink, index) => {
        const {pathname, ...others} = navLink;
        return (
            <Nav.Link key={index} as={NavLink} {...others}>{pathname}</Nav.Link>
        )
    })
}